class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    this.initUpsellSlider();
    document.addEventListener('upsell-slider:init',this.initUpsellSlider.bind(this));
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty') || document.querySelector('.drawer__inner')
          : document.getElementById('CartDrawer');
          console.log(containerToTrapFocusOn)
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  initUpsellSlider() {
    new Swiper("[js-cart-upsell-slider]", {
      slidesPerView: 2.2,  
      spaceBetween: 16,
      watchSlidesProgress: true, 
      freeMode: true,
      draggable: true, 
      autoHeight: false, 
      watchOverflow: true,
      threshold: 10,
      mousewheel: {
        forceToAxis: true 
      },
      breakpoints: {
        0: { 
          slidesPerView: 2, 
          spaceBetween: 12 
        }, 
        768: { 
          slidesPerView: 2.2, 
          spaceBetween: 16 
        }  
      }
    });
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    if(this.querySelector("cart-drawer-items.is-empty")) this.classList.add('is-empty');

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      document.dispatchEvent(new CustomEvent("upsell-slider:init"));
      initReviews();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

 document.addEventListener('quizKitAddToCartSuccess', function (e) {
  fetch(window.Shopify.routes.root + "?section_id=cart-drawer")
    .then(response => response.text())
    .then((response) => {
      const newCart = new DOMParser().parseFromString(response, 'text/html').getElementById('CartDrawer').innerHTML;
      document.getElementById('CartDrawer').innerHTML = newCart;

      const cartDrawer = document.querySelector('cart-drawer');

      cartDrawer.classList.remove('is-empty');

      setTimeout(() => {
        cartDrawer.querySelector('#CartDrawer-Overlay').addEventListener('click', cartDrawer.close.bind(cartDrawer));
        // cartDrawer.open();
        let toast = document.createElement('div');
  toast.innerText = "✅ Added to cart";
  toast.style.position = "fixed";
  toast.style.top = "20px";
  toast.style.right = "20px";
  toast.style.background = "#222";
  toast.style.color = "#fff";
  toast.style.padding = "10px 15px";
  toast.style.borderRadius = "6px";
  toast.style.fontSize = "14px";
  toast.style.zIndex = "9999";
  document.body.appendChild(toast);
  
  setTimeout(() => toast.remove(), 2500);
        cartDrawer.initUpsellSlider()
      });
    });

  fetch(window.Shopify.routes.root + "?section_id=cart-icon-bubble")
    .then(response => response.text())
    .then((response) => {
      const newBubble = new DOMParser().parseFromString(response, 'text/html').querySelector('.shopify-section').innerHTML;
      document.getElementById('cart-icon-bubble').innerHTML = newBubble;
    });
}, false); 


document.addEventListener("rebuy.add", function () {
  const url = `${window.Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`;

  fetch(url, {
    method: "GET",
    headers: { "X-Requested-With": "XMLHttpRequest" }
  })
    .then(res => res.json())
    .then(data => {
      const drawerHTML = data["cart-drawer"];
      const drawerDoc = new DOMParser().parseFromString(drawerHTML, "text/html");

      const newDrawerContent = drawerDoc.querySelector("[js-main-cart-drawer]");

      const bubbleHTML = data["cart-icon-bubble"];
      const bubbleDoc = new DOMParser().parseFromString(bubbleHTML, "text/html");

      const newBubbleContent = bubbleDoc.querySelector("#cart-icon-bubble");

      const cartDrawer = document.querySelector("cart-drawer");
      const cartDrawerMain = cartDrawer.querySelector("[js-main-cart-drawer]");
      const cartIconBubble = document.querySelector("#cart-icon-bubble");

      
      if (newBubbleContent && cartIconBubble) {
        cartIconBubble.innerHTML = newBubbleContent.innerHTML;
      };

      if (newDrawerContent && cartDrawerMain) {
        cartDrawerMain.innerHTML = newDrawerContent.innerHTML;

        document.dispatchEvent(new CustomEvent("upsell-slider:init"));
        initReviews();

        setTimeout(function() {
          cartDrawer.classList.remove("is-empty");
          cartDrawer?.open();
        })
      }
    })
    .catch(err => console.error("Error fetching cart sections:", err));
});
